import withRouter from "../withRouter/withRouter";
import { toPersianNumber, toEnglishNumber } from "../../classes/utils";
import React, { Component } from "react";

import "./Pay.css";

class Pay extends Component {
    constructor(props) {
        super(props);

        this.submitFormRef = React.createRef();
        this.findFormRef = React.createRef();

        this.render_payments_data_entry =
            this.render_payments_data_entry.bind(this);

        this.copy = this.copy.bind(this);
        this.submit = this.submit.bind(this);
        this.find_order = this.find_order.bind(this);
    }

    componentDidMount() {
        let { router, connection, toast, costumer } = this.props;
        let { method } = router.params;

        if (method === "offline") {
            let { id, mobile } = router.params;
            !mobile && (mobile = costumer.mobile);

            connection.get_offline_payment_methods().then((res) => {
                this.setState({ offline_methods: res.data });
            });
            id &&
                mobile &&
                connection
                    .order_exists(toEnglishNumber(id), toEnglishNumber(mobile))
                    .then((res) => {
                        this.setState({ total: res.data.total });

                        let canvas = document.createElement("canvas");
                        canvas.width = 1000;
                        canvas.height = 500;
                        let ctx = canvas.getContext("2d");

                        ctx.fillStyle = "white";
                        ctx.fillRect(0, 0, canvas.width, canvas.height);
                        ctx.font = "25px Arial";
                        ctx.fillStyle = "black";
                        ctx.textAlign = "center";

                        ctx.fillText(
                            `شماره پیش سفارش : ${toPersianNumber(id)}`,
                            500,
                            200
                        );
                        ctx.fillText(
                            ` مبلغ : ${toPersianNumber(res.data.total, true)} `,
                            500,
                            300
                        );

                        window.alert(
                            "یک تصویر شامل شماره سفارش و مبلغ سفارش برای شما ساخته شد لطفا برای جلوگیری از فراموشی شماره پیش سفارش آنرا دانلود نمایید."
                        );
                        const downloadLink = document.createElement("a");
                        downloadLink.download = `پیش-سفارش-${id}.png`;
                        canvas.toBlob(function (blob) {
                            const blobUrl = URL.createObjectURL(blob);
                            downloadLink.href = blobUrl;

                            setTimeout(function () {
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                                URL.revokeObjectURL(blobUrl);
                            }, 1000);
                        }, "image/png");
                    })
                    .catch((err) => {
                        console.log(err);
                        toast(
                            "سفارش ",
                            "سفارشی با مشخصات وارد شده یافت نشد.",
                            " danger"
                        );
                    });
        } else {
            let query = this.parse_query(router.location.search);
            if (query.PaymentStatus === "OK") {
                connection
                    .verify_online_payment(query.InvoiceID)
                    .then((res) => {
                        this.setState({
                            online_payment_status: "success",
                            success_res: res.data,
                        });
                    })
                    .catch((err) => {
                        this.setState({ online_payment_status: "unsuccess" });
                    });
            } else {
                this.setState({ online_payment_status: "unsuccess" });
            }
        }
    }

    parse_query(query) {
        let res = {};
        if (!query || typeof query != "string") return null;
        query = query.split("&");

        if (query.length < 1) return null;
        query[0] = query[0].replace("?", "");

        query.forEach((q) => {
            q = q.split("=");
            res[decodeURIComponent(q[0])] =
                q.length > 1 ? decodeURIComponent(q[1]) : "";
        });
        return res;
    }

    copy(text) {
        navigator.clipboard.writeText(text);
        this.setState({ clipboard: text });
    }

    find_order(id, mobile) {
        let { connection, toast, router } = this.props;

        if (!id) {
            toast("خطا در ورودی ها", "شماره سفارش را وارد کنید.", " warning");
        }
        if (!mobile) {
            toast("خطا در ورودی ها", "شماره موبایل را وارد کنید.", " warning");
            return;
        }
        if (id && mobile) {
            connection
                .order_exists(toEnglishNumber(id), toEnglishNumber(mobile))
                .then((res) => {
                    this.setState({ total: res.data.total });
                    router.navigate(id + "/" + mobile);
                })
                .catch((err) => {
                    toast(
                        "سفارش ",
                        "سفارشی با مشخصات وارد شده یافت نشد.",
                        " danger"
                    );
                });
        }
    }

    submit() {
        let { connection, toast, router } = this.props;
        let { id, mobile } = router.params;

        let formData = Object.fromEntries(
            new FormData(this.submitFormRef.current)
        );

        let keys = Object.keys(formData);
        let count = keys.length / 5;
        let entries = [];

        for (let index = 0; index < count; index++) {
            keys.forEach((key) => {
                key.includes("amount-") &&
                    (formData[key] =
                        formData[key].length > 0
                            ? parseInt(
                                  toEnglishNumber(
                                      (formData[key] || "0").replaceAll(",", "")
                                  )
                              )
                            : formData[key]);

                if (key.includes(`-${index}`)) {
                    if (entries.length <= index) {
                        entries.push({});
                    }
                    entries[index][key.replace(`-${index}`, "")] =
                        formData[key];
                }
            });
        }

        if (entries.length === 0) {
            toast("فیش", "حداقل یک فیش واریز وارد کنید ", " warning");
            return;
        }
        if (
            entries.findIndex((e) => {
                return e.comment === "" || !e.comment;
            }) > -1
        ) {
            toast(
                "فیش",
                "ثبت ساعت واریز و توضیحات برای تمام فیش ها اجباری است ",
                " warning"
            );
            return;
        }
        connection
            .submit_offline_payment({
                entries,
                order_id: toEnglishNumber(id),
                mobile: toEnglishNumber(formData.mobile || mobile),
            })
            .then((res) => {
                toast(
                    "ثبت فیش",
                    "ثبت اطلاعات واریز با موفقیت ثبت شد.",
                    " confirm"
                );
                setTimeout(() => {
                    router.navigate("/pay/offline");
                }, 3000);
            })
            .catch((err) => {
                console.log(err);
                err.response.status == 404
                    ? toast(
                          "ثبت فیش",
                          "سفارش یافت نشد .مجددا شماره سفارش و شماره موبایل را چک کنید. شماره موبایل با شماره موبایلی که هنگام ثبت سفارش وارد کردید مطابقت داشته باشد.",
                          " danger",
                          20000
                      )
                    : err.response.status == 401
                    ? toast(
                          "ثبت فیش",
                          "این سفارش به صئرت آنلاین پرداخت شده است",
                          " danger",
                          20000
                      )
                    : toast(
                          "ثبت فیش",
                          "ثبت اطلاعات واریز با خطا مواجه شد." + err,
                          " danger"
                      );
            });
    }

    render_payments_data_entry(total) {
        let { paymentsDataCount } = this.state;

        let data = [];
        for (let index = 0; index < paymentsDataCount; index++) {
            data.push(
                <div className='entry' key={index}>
                    <div className='method'>
                        <div className='caption'>روش واریز</div>
                        <select name={"method-" + index} form='form'>
                            <option value='card'>کارت به کارت</option>
                            <option value='account'>حساب به حساب</option>
                            <option value='paya'>پایا</option>
                        </select>
                    </div>
                    <div className='amount'>
                        <div className='caption'>
                            مبلغ
                            <span className='caption text info'> (تومان)</span>
                        </div>
                        <input
                            type='text'
                            name={"amount-" + index}
                            form='form'
                            onChange={(ev) => {
                                ev.target.value = toPersianNumber(
                                    parseInt(
                                        toEnglishNumber(
                                            (ev.target.value || "0").replaceAll(
                                                ",",
                                                ""
                                            ) || 0
                                        ) || 0
                                    ) || 0,
                                    true
                                );
                            }}
                            defaultValue={
                                index === 0
                                    ? total
                                        ? toPersianNumber(total || 0, true)
                                        : null
                                    : null
                            }
                        />
                    </div>
                    <div className='tracking'>
                        <div className='caption'>پیگیری</div>

                        <input
                            type='text'
                            name={"tracking-" + index}
                            form='form'
                        />
                    </div>

                    <div className='name'>
                        <div className='caption'>
                            نام صاحب (حساب / کارت) مبدا
                        </div>
                        <input type='text' name={"name-" + index} form='form' />
                    </div>

                    <div className='comment'>
                        <div className='caption'>
                            توضیحات
                            <span className='caption text info'>
                                (ساعت واریز )
                            </span>
                            <span className='caption text info'>(اجباری)</span>
                        </div>
                        <input
                            type='text'
                            name={"comment-" + index}
                            form='form'
                            required
                        />
                    </div>
                    {index === paymentsDataCount - 1 && (
                        <div className='delete'>
                            <i
                                className='ri-delete-bin-7-line btn danger'
                                onClick={() => {
                                    this.setState({
                                        paymentsDataCount:
                                            paymentsDataCount - 1,
                                    });
                                }}
                            ></i>
                        </div>
                    )}
                </div>
            );
        }

        return data;
    }
    state = {
        offline_methods: null,
        paymentsDataCount: 1,
        clipboard: null,
        online_payment_status: null,
        success_res: null,
    };
    render() {
        let {
            offline_methods,
            paymentsDataCount,
            clipboard,
            total,
            online_payment_status,
            success_res,
        } = this.state;
        let { router, connection, toast, costumer } = this.props;
        let { method, id } = router.params;

        let mobile = "",
            _id = "";

        return (
            <div className='PayComponent'>
                <div className='PayContainer'>
                    {offline_methods && (
                        <div className='methods'>
                            <div className='table'>
                                <div className='method'>
                                    <div className='method_name'>نام روش</div>
                                    <div className='bank'>نام بانک</div>
                                    <div className='name'>نام صاحب حساب</div>
                                    <div className='number'>شماره</div>
                                    <div className='copy'>کپی</div>
                                </div>
                                {offline_methods.map((m, index) => {
                                    return (
                                        <div className='method' key={index}>
                                            <div className='method_name'>
                                                {m.method}
                                            </div>
                                            <div className='bank'>{m.bank}</div>
                                            <div className='name'>{m.name}</div>
                                            <div
                                                className='number'
                                                onClick={(ev) =>
                                                    this.copy(m.number)
                                                }
                                            >
                                                {(
                                                    (m.number &&
                                                        m.number.match(
                                                            /.{1,4}/g
                                                        )) ||
                                                    []
                                                ).join("-")}
                                            </div>
                                            <div
                                                className='copy '
                                                onClick={(ev) =>
                                                    this.copy(m.number)
                                                }
                                            >
                                                <i
                                                    className={`ri-file-copy-line btn${
                                                        clipboard === m.number
                                                            ? " confirm"
                                                            : " info"
                                                    }`}
                                                >
                                                    {` کپی 
                                                        ${
                                                            clipboard ===
                                                            m.number
                                                                ? "شد"
                                                                : "کردن"
                                                        }`}
                                                </i>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    <div className='help'>
                        <i class='ri-error-warning-line text '></i>
                        مبلغ سفارش را با استفاده از روش های بالا (کارت به کارت -
                        شبا - حساب به حساب) واریز نمایید سپس اطلاعات واریز و
                        زمان واریز را در قسمت پایین وارد نمایید.
                    </div>

                    {method &&
                        method === "offline" &&
                        (id ? (
                            <div className='offline'>
                                <div className='id text info'>
                                    شماره پیش سفارش :
                                    <div className='text confirm'>
                                        {toPersianNumber(id)}
                                    </div>
                                </div>
                                <div className='total text primary'>
                                    {total &&
                                        toPersianNumber(total.toString(), true)}
                                    تومان
                                </div>
                                <div className='enterPaymentData'>
                                    <div className='caption text info'>
                                        <i className='ri-error-warning-line'></i>
                                        اطلاعات واریزی های خود را وارد نمایید
                                    </div>
                                    <div className='caption text info'>
                                        <i className='ri-error-warning-line'></i>
                                        در صورت واریز طی چند مرحله بر روی
                                        <i
                                            className='ri-add-line btn info'
                                            onClick={(ev) => {
                                                this.setState({
                                                    paymentsDataCount:
                                                        paymentsDataCount + 1,
                                                });
                                            }}
                                        ></i>
                                        در پایین صفحه کلیک نمایید
                                    </div>
                                    <div className='caption text danger'>
                                        <i className='ri-error-warning-line text warning'></i>
                                        لطفا جهت تسریع در عملیات تایید سفارش
                                        تمام فیلد ها را پر کنید.
                                    </div>
                                    <form
                                        id='form'
                                        ref={this.submitFormRef}
                                    ></form>
                                    {this.render_payments_data_entry(total)}
                                    <button
                                        className='btn info'
                                        onClick={(ev) => {
                                            this.setState({
                                                paymentsDataCount:
                                                    paymentsDataCount + 1,
                                            });
                                        }}
                                    >
                                        <i className='ri-add-line '></i>
                                    </button>
                                </div>
                                <div className='submit'>
                                    <button
                                        className='submit btn confirm'
                                        onClick={this.submit}
                                        type='submit'
                                    >
                                        <i className='ri-check-double-line'></i>
                                        ثبت اطلاعات
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className='no_order_id'>
                                <form
                                    id='findForm'
                                    ref={this.findFormRef}
                                ></form>
                                <div className='order_id text info'>
                                    <div className='caption'>
                                        شماره پیش سفارش :
                                    </div>
                                    <input
                                        type='text'
                                        placeholder='شماره سفارش خود را وارد نمایید'
                                        name='id'
                                        form='findForm'
                                        onChange={(ev) => {
                                            _id = ev.target.value;
                                        }}
                                    />
                                </div>

                                {costumer && !costumer.mobile && (
                                    <div className='mobile text info'>
                                        <div>
                                            شماره همراه :
                                            <span className='text danger'>
                                                *
                                            </span>
                                            <input
                                                type='tel'
                                                placeholder=''
                                                name='mobile'
                                                form='findForm'
                                                onChange={(ev) => {
                                                    mobile = ev.target.value;
                                                }}
                                            />
                                        </div>
                                        <div className='notice'>
                                            <i className='ri-error-warning-line '></i>
                                            شماره همراهی که زمان سفارش وارد
                                            کردید
                                        </div>
                                    </div>
                                )}

                                <div className='find'>
                                    <button
                                        className='btn info'
                                        onClick={(ev) =>
                                            this.find_order(
                                                id || _id,
                                                costumer.mobile || mobile
                                            )
                                        }
                                    >
                                        یافتن سفارش
                                    </button>
                                </div>
                            </div>
                        ))}
                    {method && method === "online" && (
                        <div className='online'>
                            {online_payment_status === "success" ? (
                                <div className='success'>
                                    <div className='message text confirm'>
                                        تراکنش موفق. پرداخت انجام شد.
                                    </div>
                                    {success_res && (
                                        <div className='detail'>
                                            <div className='ref'>
                                                <div className='name'>
                                                    شماره مرجع بانک
                                                </div>
                                                <div className='value'>
                                                    {toPersianNumber(
                                                        success_res.ref_id
                                                    )}
                                                </div>
                                            </div>
                                            <div className='amount'>
                                                <div className='name'>
                                                    مقدار
                                                </div>
                                                <div className='value'>
                                                    {toPersianNumber(
                                                        success_res.amount / 10,
                                                        true
                                                    )}
                                                    تومان
                                                </div>
                                            </div>
                                            <div className='invoice'>
                                                <div className='name'>
                                                    شماره سفارش
                                                </div>
                                                <div className='value'>
                                                    {toPersianNumber(
                                                        success_res.invoice_id
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) : online_payment_status === "unsuccess" ? (
                                <div className='unsuccess'>
                                    <div className='message text danger'>
                                        تراکنش ناموفق. پرداخت انجام نشد.
                                    </div>
                                </div>
                            ) : (
                                <div className=' message waiting text info'>
                                    در حال استعلام لطفا منتظر بمانید...
                                </div>
                            )}
                            <a href='/' className='btn info'>
                                بازگشت به صفحه اصلی
                            </a>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default withRouter(Pay);
